import React, {FunctionComponent} from "react";

const SvgUnderConstruction: FunctionComponent = () => {
    return (
        <svg
            id="Layer_1"
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 510.15 359.76"
            width="406"
            height="306"
            className="illustration styles_illustrationTablet__1DWOa"
        >
            <defs>
                <linearGradient
                    id="svg-under-construction-linear-gradient"
                    x1="429.36"
                    y1="225.03"
                    x2="432.77"
                    y2="273.94"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stopColor="#010101" stopOpacity="0"/>
                    <stop offset="0.95" stopColor="#010101"/>
                </linearGradient>
                <linearGradient
                    id="svg-under-construction-linear-gradient-2"
                    x1="213.3"
                    y1="280.85"
                    x2="217.12"
                    y2="335.08"
                    xlinkHref="#svg-under-construction-linear-gradient"
                />
                <linearGradient
                    id="svg-under-construction-linear-gradient-3"
                    x1="160.76"
                    y1="309.98"
                    x2="263.86"
                    y2="289.64"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stopColor="#010101" stopOpacity="0"/>
                    <stop
                        offset="0.35"
                        stopColor="#010101"
                        stopOpacity="0.35"
                    />
                    <stop offset="0.95" stopColor="#010101"/>
                </linearGradient>
                <linearGradient
                    id="svg-under-construction-linear-gradient-4"
                    x1="231.52"
                    y1="309.98"
                    x2="334.62"
                    y2="289.64"
                    xlinkHref="#svg-under-construction-linear-gradient-3"
                />
                <linearGradient
                    id="svg-under-construction-linear-gradient-5"
                    x1="241.94"
                    y1="197.22"
                    x2="952.31"
                    y2="160.28"
                    xlinkHref="#svg-under-construction-linear-gradient"
                />
                <linearGradient
                    id="svg-under-construction-linear-gradient-6"
                    x1="201.21"
                    y1="195.59"
                    x2="294.38"
                    y2="190.74"
                    xlinkHref="#svg-under-construction-linear-gradient"
                />
                <linearGradient
                    id="svg-under-construction-linear-gradient-7"
                    x1="140.18"
                    y1="199.67"
                    x2="562.54"
                    y2="99.67"
                    xlinkHref="#svg-under-construction-linear-gradient"
                />
                <linearGradient
                    id="svg-under-construction-linear-gradient-8"
                    x1="142.97"
                    y1="198.61"
                    x2="563.47"
                    y2="99.05"
                    xlinkHref="#svg-under-construction-linear-gradient"
                />
                <linearGradient
                    id="svg-under-construction-linear-gradient-9"
                    x1="360.86"
                    y1="217.84"
                    x2="515.31"
                    y2="353.38"
                    xlinkHref="#svg-under-construction-linear-gradient"
                />
                <linearGradient
                    id="svg-under-construction-linear-gradient-10"
                    x1="353.28"
                    y1="227.41"
                    x2="368.97"
                    y2="227.41"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stopColor="#e5c6d6"/>
                    <stop offset="0.42" stopColor="#ead4d0"/>
                    <stop offset="1" stopColor="#f0e9cb"/>
                </linearGradient>
                <linearGradient
                    id="svg-under-construction-linear-gradient-11"
                    x1="6.56"
                    y1="170.6"
                    x2="1891.15"
                    y2="72.59"
                    xlinkHref="#svg-under-construction-linear-gradient"
                />
                <linearGradient
                    id="svg-under-construction-linear-gradient-12"
                    x1="-597.66"
                    y1="226.59"
                    x2="-578.4"
                    y2="226.59"
                    gradientTransform="matrix(-1, 0, 0, 1, -157.58, 0)"
                    xlinkHref="#svg-under-construction-linear-gradient-10"
                />
                <linearGradient
                    id="svg-under-construction-linear-gradient-13"
                    x1="426.9"
                    y1="207.42"
                    x2="441.17"
                    y2="225.32"
                    xlinkHref="#svg-under-construction-linear-gradient"
                />
                <linearGradient
                    id="svg-under-construction-linear-gradient-14"
                    x1="429.31"
                    y1="203.21"
                    x2="464.72"
                    y2="247.62"
                    xlinkHref="#svg-under-construction-linear-gradient"
                />
                <linearGradient
                    id="svg-under-construction-linear-gradient-15"
                    x1="429.46"
                    y1="203.41"
                    x2="455.91"
                    y2="236.58"
                    xlinkHref="#svg-under-construction-linear-gradient"
                />
                <linearGradient
                    id="svg-under-construction-linear-gradient-16"
                    x1="428.66"
                    y1="214.36"
                    x2="358.06"
                    y2="244.79"
                    xlinkHref="#svg-under-construction-linear-gradient"
                />
                <linearGradient
                    id="svg-under-construction-linear-gradient-17"
                    x1="-592.58"
                    y1="272.4"
                    x2="-583.59"
                    y2="272.4"
                    gradientTransform="matrix(-1, 0, 0, 1, -157.58, 0)"
                    xlinkHref="#svg-under-construction-linear-gradient-10"
                />
                <linearGradient
                    id="svg-under-construction-linear-gradient-18"
                    x1="426.36"
                    y1="328.05"
                    x2="444.16"
                    y2="190.58"
                    xlinkHref="#svg-under-construction-linear-gradient"
                />
                <linearGradient
                    id="svg-under-construction-linear-gradient-19"
                    x1="131.97"
                    y1="78.14"
                    x2="131.97"
                    y2="78.14"
                    xlinkHref="#svg-under-construction-linear-gradient"
                />
                <linearGradient
                    id="svg-under-construction-linear-gradient-20"
                    x1="105.96"
                    y1="81.66"
                    x2="457.71"
                    y2="-1.63"
                    xlinkHref="#svg-under-construction-linear-gradient"
                />
                <linearGradient
                    id="svg-under-construction-linear-gradient-21"
                    x1="106.62"
                    y1="83.83"
                    x2="454.37"
                    y2="1.49"
                    xlinkHref="#svg-under-construction-linear-gradient"
                />
                <linearGradient
                    id="svg-under-construction-linear-gradient-22"
                    x1="107.9"
                    y1="161.11"
                    x2="108.73"
                    y2="496.51"
                    xlinkHref="#svg-under-construction-linear-gradient"
                />
                <linearGradient
                    id="svg-under-construction-linear-gradient-23"
                    x1="108.1"
                    y1="35.91"
                    x2="108.93"
                    y2="371.29"
                    xlinkHref="#svg-under-construction-linear-gradient"
                />
                <linearGradient
                    id="svg-under-construction-linear-gradient-24"
                    x1="77.22"
                    y1="73.44"
                    x2="155.26"
                    y2="54.96"
                    xlinkHref="#svg-under-construction-linear-gradient"
                />
                <linearGradient
                    id="svg-under-construction-linear-gradient-25"
                    x1="77.71"
                    y1="75.03"
                    x2="152.81"
                    y2="57.25"
                    xlinkHref="#svg-under-construction-linear-gradient"
                />
                <linearGradient
                    id="svg-under-construction-linear-gradient-26"
                    x1="122.05"
                    y1="354.33"
                    x2="61.88"
                    y2="381.87"
                    xlinkHref="#svg-under-construction-linear-gradient"
                />
            </defs>
            <path
                d="M451.19,387.71c-39.79,20.46-85.8,19.5-129.87,18.15l-153-4.79c-14.9-.45-29.92-.93-44.7-2.89A175,175,0,0,1,98.06,393c-3.22-.93-6.38-1.95-9.54-3.13-1.63-.6-3.22-1.23-4.82-1.92a128.91,128.91,0,0,1-25.37-14.3,142.44,142.44,0,0,1-47.4-59.5C2.05,293.26-2,268.7,5.72,247.27,20,207.6,65,195.26,100.26,175.91c33.23-18.24,61.1-47,80-81.56,21.82-39.88,23.92-50.12,71.36-47.17,44.84,2.77,92.49,6.6,128.69,35.19C401,98.65,416,121.68,430.67,144.25q28.62,44.06,57.24,88.15c8.25,12.7,16.62,25.68,20.86,40.45C521.77,318.18,491,367.24,451.19,387.71Z"
                transform="translate(-1.64 -46.71)"
                fill="var(--color-yellow-light)"
                opacity="0.24"
                style={{isolation: "isolate"}}
            />
            <ellipse
                cx="291.51"
                cy="335.87"
                rx="156.49"
                ry="13.56"
                fill="var(--color-orange)"
                opacity="0.24"
                style={{isolation: "isolate"}}
            />
            <polygon
                points="81.24 65.4 101.41 57.07 212.32 67.47 212.32 78.02 81.24 78.41 81.24 65.4"
                fill="var(--color-orange)"
            />
            <rect
                x="98.05"
                y="53.8"
                width="19.85"
                height="275.75"
                fill="var(--color-orange)"
            />
            <path
                d="M439.55,234.86s12.84,6.63,13.05,11.6,3.31,26.5,3.31,26.5l-8.7,3.73,1.19,17.59a4.07,4.07,0,0,1-3.67,4.34c-8.15.8-30.07-2-29.84-4.49,2.8-30-1.34-52,4-55.12s12.59-4.11,12.59-4.11Z"
                transform="translate(-1.64 -46.71)"
                fill="var(--color-red)"
            />
            <polygon
                points="445.57 229.98 433.59 231.58 432.04 229.56 413.95 231.58 414.18 233.29 432.19 234.06 436.08 237.48 445.86 236.39 445.57 229.98"
                opacity="0.5"
                fill="url(#svg-under-construction-linear-gradient)"
            />
            <path
                d="M403,158.39V335a8.59,8.59,0,0,1-8.6,8.6H164a7.88,7.88,0,0,1-8-9V158c-.62-4.35,3.22-8.19,8-8.19H394.37A8.59,8.59,0,0,1,403,158.39Z"
                transform="translate(-1.64 -46.71)"
                fill="var(--color-grey)"
            />
            <rect
                x="161.86"
                y="287.85"
                width="104.52"
                height="9.04"
                opacity="0.5"
                fill="url(#svg-under-construction-linear-gradient-2)"
            />
            <rect
                x="243.21"
                y="287.01"
                width="9.89"
                height="69.56"
                fill="#fff"
            />
            <rect
                x="172.59"
                y="287.01"
                width="9.89"
                height="67.23"
                fill="#fff"
            />
            <polygon
                points="172.66 323.73 182.62 323.73 182.62 289.62 172.45 289.62 172.66 323.73"
                opacity="0.5"
                fill="url(#svg-under-construction-linear-gradient-3)"
            />
            <polygon
                points="243.42 323.73 253.38 323.73 253.38 289.62 243.21 289.62 243.42 323.73"
                opacity="0.5"
                fill="url(#svg-under-construction-linear-gradient-4)"
            />
            <rect
                x="301.14"
                y="129.77"
                width="86.96"
                height="124.22"
                opacity="0.5"
                fill="url(#svg-under-construction-linear-gradient-5)"
            />
            <polygon
                points="291.21 129.77 291.21 254.01 204.25 254.01 204.25 245.28 253.32 245.28 253.32 129.77 291.21 129.77"
                opacity="0.5"
                fill="url(#svg-under-construction-linear-gradient-6)"
            />
            <rect
                x="166.36"
                y="121.08"
                width="86.96"
                height="124.2"
                opacity="0.5"
                fill="url(#svg-under-construction-linear-gradient-7)"
            />
            <rect
                x="168.85"
                y="121.18"
                width="86.96"
                height="122.03"
                opacity="0.5"
                fill="url(#svg-under-construction-linear-gradient-8)"
            />
            <path
                d="M353.57,223.45s-1.57-.13-1.1.88,3.73,1.49,3.65,2c-1.4,8.77,6.21,10,9.47,9.16s37.19,18.82,37.19,18.82l.31-17.81Z"
                transform="translate(-1.64 -46.71)"
                fill="url(#svg-under-construction-linear-gradient-9)"
            />
            <path
                d="M363.86,224.23c-3.28-.74-6.57-1.49-9.9-1.91a.77.77,0,0,0-.45,0c-.38.19-.22.78.06,1.1,1,1.07,2.53,1.29,3.86,1.84a.46.46,0,0,1,.27.22.49.49,0,0,1,0,.29,6.47,6.47,0,0,0-.27,3.26,4.11,4.11,0,0,0,1.77,2.69,6.3,6.3,0,0,0,2.81.72,7.64,7.64,0,0,0,3.43-.31,12.77,12.77,0,0,1,2-.86c.44-.09.95-.09,1.22-.44a1.21,1.21,0,0,0,.21-.62c.18-1.3.28-3.24-.74-4.22A8.9,8.9,0,0,0,363.86,224.23Z"
                transform="translate(-1.64 -46.71)"
                fill="url(#svg-under-construction-linear-gradient-10)"
            />
            <path
                d="M403,158.39v4.24H155.37v-4.24a8.59,8.59,0,0,1,8.61-8.6H394.37A8.59,8.59,0,0,1,403,158.39Z"
                transform="translate(-1.64 -46.71)"
                fill="var(--color-green)"
            />
            <path
                d="M421.21,219.76a3.83,3.83,0,0,0-.38,1.14,5.77,5.77,0,0,0,.87,2.75c.95,2.23.81,5.16,2.79,6.55,1.1.77,2.55.79,3.8,1.27a5.52,5.52,0,0,1,3.23,3.43c.44,1.4-1.46,6.61-.09,7.13s3.59-1,4.89-1.94c1.55-1.08,2.95-2,3.1-3.53.53-5.42,1.05-10.91.23-16.3a13.77,13.77,0,0,0-1.41-4.66,9,9,0,0,0-6.83-4.52C425.29,210.45,423.29,215.09,421.21,219.76Z"
                transform="translate(-1.64 -46.71)"
                fill="url(#svg-under-construction-linear-gradient-12)"
            />
            <path
                d="M421.73,210.92a3.76,3.76,0,0,0,.9,3.55c1.69,1.77,4.77,1.59,6.39,3.42a7.26,7.26,0,0,1,1.22,2.4c.2.55.57,1.2,1.15,1.12.79-.11.73-1.38,1.39-1.84a1.27,1.27,0,0,1,1.68.58c.74,1.26-.07,2.92-1.25,3.79-.09.06-.19.14-.18.25s.06.13.11.19l3.48,3.74a3.28,3.28,0,0,0,1.5,1.09c1.11.26,2.11-.66,2.88-1.5l3.43-3.77a9.26,9.26,0,0,0,1.53-2.06,8.86,8.86,0,0,0,.41-4.55,13.44,13.44,0,0,0-1-4.68,9.77,9.77,0,0,0-3.83-3.9c-4.69-2.85-10.45-3.29-15.93-3-1.39.08-.8,1.48-1.46,2.34C423.37,209.18,422.14,209.45,421.73,210.92Z"
                transform="translate(-1.64 -46.71)"
                fill="#606161"
            />
            <path
                d="M421.57,211.68a9.53,9.53,0,0,0,.31,1.47c.12.2,23.1,8.43,23.1,8.43s1,.27,1.08-.28.35-1.43.35-1.43Z"
                transform="translate(-1.64 -46.71)"
                fill="url(#svg-under-construction-linear-gradient-13)"
            />
            <path
                d="M450,215.48a15.49,15.49,0,0,1-.39,4s-1.33,1-5,.05-27-9.22-27-9.22-.35-1.42,1-1.55h0a5.62,5.62,0,0,0,2.87-1.54s4.89-10.81,18.17-5.78C448.28,204.67,449.92,211.25,450,215.48Z"
                transform="translate(-1.64 -46.71)"
                fill="var(--color-orange)"
            />
            <path
                d="M450,215.48a14,14,0,0,1-.35,2.08,4.45,4.45,0,0,1-2.91.44,10.92,10.92,0,0,1-2-.36c-2.21-.57-11.52-3.79-18.62-6.26-3.26-1.15-6-2.16-7.41-2.65a5.62,5.62,0,0,0,2.87-1.54s4.89-10.81,18.17-5.78C448.28,204.67,449.92,211.25,450,215.48Z"
                transform="translate(-1.64 -46.71)"
                opacity="0.5"
                fill="url(#svg-under-construction-linear-gradient-14)"
            />
            <path
                d="M446.74,218a10.92,10.92,0,0,1-2-.36c-2.21-.57-11.52-3.79-18.62-6.26a.67.67,0,0,0,.13-.18s3.58-10.81,13.15-5.78C444.89,208.33,446.47,213.85,446.74,218Z"
                transform="translate(-1.64 -46.71)"
                opacity="0.5"
                fill="url(#svg-under-construction-linear-gradient-15)"
            />
            <polygon
                points="421.09 205.96 402.38 207.51 413.95 231.58 432.19 231.01 421.09 205.96"
                fill="#fff"
            />
            <polygon
                points="420.6 206.68 402.38 207.51 413.95 231.58 432.19 231.01 420.6 206.68"
                opacity="0.5"
                fill="url(#svg-under-construction-linear-gradient-16)"
            />
            <path
                d="M427.46,268.31c-.41.06-.91.21-1,.62s.5.77,1,.9l1.81.5a4.7,4.7,0,0,0-2.59-.29c-.27,0-.59.16-.65.43s.43.65.84.72l2.38.43a3.5,3.5,0,0,0-2.36.29.58.58,0,0,0-.26.23c-.13.29.26.53.57.61a18.3,18.3,0,0,0,2.64.49l-1.67,0a.84.84,0,0,0-.58.15.6.6,0,0,0,.14.89,1.78,1.78,0,0,0,1,.22l1.4,0a2.47,2.47,0,0,1,.82.12c.78.33,1,1.4,1.76,1.79a1.58,1.58,0,0,0,1.92-.65,3.09,3.09,0,0,0,.31-2.16,5.83,5.83,0,0,0-2.81-3.95C430.48,268.63,429.51,268,427.46,268.31Z"
                transform="translate(-1.64 -46.71)"
                fill="url(#svg-under-construction-linear-gradient-17)"
            />
            <polygon
                points="446.09 250.06 440.19 291.05 447.33 338.57 442.67 339.19 428.7 294.47 426.83 273.35 410.69 337.01 406.65 337.01 414.39 247.99 446.09 250.06"
                fill="var(--color-midnight-light)"
            />
            <polygon
                points="446.09 250.06 440.19 291.05 447.33 338.57 442.67 339.19 428.7 294.47 426.83 273.35 410.69 337.01 406.65 337.01 410.63 291.28 414.39 247.99 446.09 250.06"
                fill="url(#svg-under-construction-linear-gradient-18)"
            />
            <path
                d="M450.14,389.74c0,.12.06.26,0,.35a.42.42,0,0,1-.29.11,52.68,52.68,0,0,1-10.43,0,6.63,6.63,0,0,1,1.59-2.88,5.1,5.1,0,0,1,1.42-.85c1.38-.61,4.36-1.8,5.88-1.24C449.56,385.74,449.86,388.54,450.14,389.74Z"
                transform="translate(-1.64 -46.71)"
                fill="#606161"
            />
            <path
                d="M412.29,389.05a.43.43,0,0,1-.12.31.48.48,0,0,1-.31.1,67.23,67.23,0,0,1-9.73,0,.51.51,0,0,1-.3-.09c-.16-.15-.07-.41,0-.59a10.69,10.69,0,0,1,4.37-4.32c1.16-.59,4.2-1.67,5.43-.76S412.43,387.69,412.29,389.05Z"
                transform="translate(-1.64 -46.71)"
                fill="#606161"
            />
            <path
                d="M391.75,229.53l38.2,5.59L416.44,251h0a13.4,13.4,0,0,0-8.31-6.74L367.79,233l.31-7.45Z"
                transform="translate(-1.64 -46.71)"
                fill="var(--color-red)"
            />
            <path
                d="M132,78.14"
                transform="translate(-1.64 -46.71)"
                fill="url(#svg-under-construction-linear-gradient-19)"
            />
            <rect
                x="207.32"
                y="77.87"
                width="1.45"
                height="35.77"
                fill="#fff"
            />
            <path
                d="M168,167.79s35.73-17.8,87,0"
                transform="translate(-1.64 -46.71)"
                fill="none"
                stroke="#fff"
                strokeLinecap="round"
                strokeMiterlimit="10"
                strokeWidth="1.1"
            />
            <polygon
                points="212.32 67.47 212.32 78.02 117.91 78.02 117.91 57.28 212.32 67.47"
                fill="url(#svg-under-construction-linear-gradient-20)"
            />
            <polygon
                points="212.32 72.13 212.32 78.02 117.91 78.02 117.91 61.94 212.32 72.13"
                fill="url(#svg-under-construction-linear-gradient-21)"
            />
            <rect
                x="98.05"
                y="53.8"
                width="19.85"
                height="275.75"
                fill="url(#svg-under-construction-linear-gradient-22)"
            />
            <rect
                x="103"
                y="53.8"
                width="10.97"
                height="275.75"
                fill="url(#svg-under-construction-linear-gradient-23)"
            />
            <polygon
                points="98.05 58.6 98.05 78.41 81.24 78.41 81.24 65.4 98.05 58.6"
                fill="url(#svg-under-construction-linear-gradient-24)"
            />
            <polygon
                points="98.05 62.02 98.05 78.41 81.24 78.41 81.24 68.81 98.05 62.02"
                fill="url(#svg-under-construction-linear-gradient-25)"
            />
            <rect
                x="175.26"
                y="128.94"
                width="55.49"
                height="4.35"
                rx="2.17"
                fill="var(--color-midnight-light)"
            />
            <rect
                x="175.26"
                y="136.77"
                width="30.82"
                height="2.42"
                rx="1.21"
                fill="var(--color-midnight-light)"
            />
            <rect
                x="188.1"
                y="142.78"
                width="30.82"
                height="2.42"
                rx="1.21"
                fill="var(--color-midnight-light)"
            />
            <rect
                x="209.01"
                y="136.77"
                width="4.52"
                height="2.39"
                rx="1.19"
                fill="var(--color-midnight-light)"
            />
            <rect
                x="215.53"
                y="136.77"
                width="4.52"
                height="2.39"
                rx="1.19"
                fill="var(--color-midnight-light)"
            />
            <rect
                x="178.57"
                y="142.78"
                width="4.52"
                height="2.39"
                rx="1.19"
                fill="var(--color-midnight-light)"
            />
            <rect
                x="222.05"
                y="136.77"
                width="4.52"
                height="2.39"
                rx="1.19"
                fill="var(--color-midnight-light)"
            />
            <rect
                x="164.4"
                y="262.52"
                width="82.2"
                height="12.48"
                fill="var(--color-midnight-light)"
            />
            <rect
                x="162.28"
                y="293.01"
                width="100.42"
                height="26.27"
                fill="var(--color-orange)"
            />
            <path
                d="M162.65,338.66V366l101.89-.2-.62-27.13Zm2.61,3.48h15.52l-15.07,20h-.45Zm24.86,0h9.94l-14.91,20h-10Zm19.28,0h9.95l-14.92,20h-9.79Zm19.44,0h9.94l-15.06,20h-9.8Zm19.29,0h9.94l-14.92,20h-9.79Zm12.8,20h-8.28L260.93,351Z"
                transform="translate(-1.64 -46.71)"
                fill="#fff"
            />
            <path
                d="M119.49,348.88c-1.53,3.13-2.62,7-.78,10a40.86,40.86,0,0,0,3,3.34c4,4.88,1.89,12.22-1.24,17.67a10.73,10.73,0,0,0-1.83,4.61c-.12,2.61,1.77,4.78,3.34,6.86s2.71,4.69,1.65,6.86a159.88,159.88,0,0,1-35.09-8.31c-1.63-.6-3.22-1.23-4.82-1.92-.33-3.64.82-7.44,2.29-10.87,1.63-3.76,4.13-7.67,4.76-11.8.57-3.76-.09-7.28,1.08-11.07A25.06,25.06,0,0,1,107,338c2.11-.73,4.42-1.24,6-2.77a12,12,0,0,0,2.47-4q4.24-9.21,8.42-18.48c1.3-2.83,3-6,6.11-6.5,2.38-.39,4.76,1.18,5.93,3.28a11.74,11.74,0,0,1,1.06,7.05C135.65,328.9,125,337.8,119.49,348.88Z"
                transform="translate(-1.64 -46.71)"
                fill="var(--color-green)"
            />
            <path
                d="M119.49,348.88c-1.53,3.13-2.62,7-.78,10a40.86,40.86,0,0,0,3,3.34c4,4.88,1.89,12.22-1.24,17.67a10.73,10.73,0,0,0-1.83,4.61c-.12,2.61,1.77,4.78,3.34,6.86s2.71,4.69,1.65,6.86a159.88,159.88,0,0,1-35.09-8.31c-1.63-.6-3.22-1.23-4.82-1.92-.33-3.64.82-7.44,2.29-10.87,1.63-3.76,4.13-7.67,4.76-11.8.57-3.76-.09-7.28,1.08-11.07A25.06,25.06,0,0,1,107,338c2.11-.73,4.42-1.24,6-2.77a12,12,0,0,0,2.47-4q4.24-9.21,8.42-18.48c1.3-2.83,3-6,6.11-6.5,2.38-.39,4.76,1.18,5.93,3.28a11.74,11.74,0,0,1,1.06,7.05C135.65,328.9,125,337.8,119.49,348.88Z"
                transform="translate(-1.64 -46.71)"
                opacity="0.5"
                fill="url(#svg-under-construction-linear-gradient-26)"
            />
            <path
                d="M103.42,384.79A10.83,10.83,0,0,1,98.06,393c-3.22-.93-6.38-1.95-9.54-3.13-1.63-.6-3.22-1.23-4.82-1.92a128.91,128.91,0,0,1-25.37-14.3,31.7,31.7,0,0,1-1.2-4.69,8.28,8.28,0,0,1,3.64-8.28,30.41,30.41,0,0,0,3.85-2.2c2.68-2.2,2.71-6.38,1.36-9.54s-3.83-5.75-5.63-8.7-3-6.65-1.57-9.78c.94-2,2.83-3.46,4-5.39,2.22-3.61,1.5-8.24.69-12.4-1.08-5.65-2.17-11.28-3.28-16.94-.69-3.67-1.21-8,1.5-10.6,3.68-3.49,9.75-.69,13.4,2.8a33,33,0,0,1,9.3,14.69c3.43,12.31-2.56,26.16,2.25,38,3.22,8,10.78,13.46,14.54,21.19C104.59,368.87,104.53,377.14,103.42,384.79Z"
                transform="translate(-1.64 -46.71)"
                fill="var(--color-green)"
            />
        </svg>
    );
};

export default SvgUnderConstruction;
